import { useState } from 'react'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

import InventoryLocationForm, { InventoryLocationFormState } from '../../InventoryLocationForm'
import useCreateInventoryLocationHandler from 'views/management/inventoryLocations/effects/createInventoryLocation'
import validateForm from '../../InventoryLocationForm/helpers/validateForm'
import useValidateBranchAndName from '../../InventoryLocationForm/helpers/validateBranchAndName'

export type AddInventoryLocationModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function AddInventoryLocationModal( { onCancel, onSuccess }: AddInventoryLocationModalProps ) {
	const [ formState, setFormState ] = useState<InventoryLocationFormState>( {
		name: '',
		validation: {
			branch: { isInvalid: false },
			name: { isInvalid: false },
		},
	} )
	const [ isSaving, setIsSaving ] = useState( false )
	const validateBranchAndName = useValidateBranchAndName()
	const createStore = useCreateInventoryLocationHandler()

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Store Modal - Click - Cancel', {} )
		onCancel()
	}

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Add Store Modal - Click - Create Store', {} )
		setIsSaving( true )

		const { isInvalid, newFormState } = await validateForm( formState, validateBranchAndName )
		if ( isInvalid ) {
			setFormState( newFormState )
			setIsSaving( false )
		} else {
			try {
				await createStore( formState.branch?.id ?? 0, formState.name )
			} catch ( e: unknown ) {
				setIsSaving( false )
			}
			onSuccess()
		}
	}

	return (
		<>
			<EuiModalBody>
				<InventoryLocationForm
					formState={formState}
					setFormState={setFormState}
					hasBranch
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Add store
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
